import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=2f25b95c&scoped=true&lang=pug&"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./ImageThumbnail.vue?vue&type=style&index=0&id=2f25b95c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f25b95c",
  null
  
)

export default component.exports